import { render, staticRenderFns } from "./SimpleLoginComponent.vue?vue&type=template&id=1fb07f1f&scoped=true"
import script from "./SimpleLoginComponent.vue?vue&type=script&lang=js"
export * from "./SimpleLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./SimpleLoginComponent.vue?vue&type=style&index=0&id=1fb07f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb07f1f",
  null
  
)

export default component.exports